/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { GlobalConfig } from '@/features/globalConfig';

type CustomScriptData = {
  c?: string;
  async?: boolean;
} & {
  [key: string]: string | boolean;
};

export function getCustomScripts(globalConfig: GlobalConfig | undefined): CustomScriptData[] {
  if (globalConfig) {
    const matchedValues = [];
    for (const [key, value] of Object.entries(globalConfig)) {
      const match = key.match(/^HEADJS_(\d+)$/);

      if (match && typeof value === 'string') {
        const index = parseInt(match[1]);
        try {
          matchedValues[index] = JSON.parse(value) as CustomScriptData;
        } catch {
          // ignore invalid JSON payloads
        }
      }
    }
    return matchedValues;
  }

  return [];
}
